import React from "react";
import ReactGA from "react-ga";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";

if (process.env.GA) {
  ReactGA.initialize(process.env.GA, {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  });
} else {
  ReactGA.initialize("UA-92545515-1", {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  });
}

@inject("authStore")
@withRouter
@observer
class GAListener extends React.Component {
  componentDidMount() {
    this.sendPageChange(
      this.props.location.pathname,
      this.props.location.search
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      this.sendPageChange(
        this.props.location.pathname,
        this.props.location.search
      );
    }
  }

  sendPageChange(pathname, search) {
    const page = pathname + search;
    ReactGA.set({
      page: page,
      userId: this.props.authStore.user.id,
    });
    ReactGA.pageview(page);
  }

  render() {
    return null;
  }
}

export default GAListener;



// WEBPACK FOOTER //
// ./src/GAListener.js